import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { Auth0Accesses } from "./accesses.ts";
import { Auth0Components } from "./components.ts";

// Rule filter values compile to regular expressions, so a rule can say, e.g.,
// that a role named `Admin` in any tenant needs approval.
const Auth0Filters = {
  tenant: { keys: ["name"] },
  role: { keys: ["name"] },
  api: { keys: ["name"] },
  permission: { keys: ["name"] },
  organization: { keys: ["name"] },
} as const satisfies AnyFilterSchema;
export type Auth0Filters = typeof Auth0Filters;

// Keyed by component, so a new component doesn't compile until it has one.
// The new item's form labels an item's id with its component's kind, then
// this: "Connector ID", "Tenant domain".
const IDENTIFIERS: Record<keyof typeof Auth0Components, string> = {
  connector: "ID",
  tenant: "domain",
};
// `Registration` can hand `identifier` a string that isn't a component key.
const identifiers: Partial<Record<string, string>> = IDENTIFIERS;

export const Auth0Registration = Registration({
  accesses: Auth0Accesses,
  category: "resource",
  components: Auth0Components,
  docs: { install: "auth0", request: "auth0/requesting-access" },
  filters: Auth0Filters,
  identifier: (component) => identifiers[component] ?? component,
  // Each component is named for what one of its items is.
  itemKind: (component) => component,
  label: "Auth0",
  logoUrl: "https://cdn.auth0.com/website/website/favicons/auth0-favicon.svg",
  maturity: "beta",
  requestType: "requestable",
  useMapping: [{ component: "tenant", use: "iam_write" }],
});

registerIntegration("auth0", Auth0Registration);
